import { axiosInstance } from "../queries/client";

interface MediaUploadResponse {
  "@id": string;
  id: string;
  url: string;
  contentUrl?: string;
  mediaIri?: string;
}

interface UploadMediaParams {
  file: File;
  onSuccess: (response: MediaUploadResponse, file: File) => void;
  onError: (error: Error) => void;
}

export const uploadMedia = async ({
  file,
  onSuccess,
  onError,
}: UploadMediaParams): Promise<MediaUploadResponse | null> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileName", file.name);

  return axiosInstance
    .post("/media", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      const data: MediaUploadResponse = response.data;

      if (data) {
        data.mediaIri = data["@id"];
      }
      onSuccess(data, file);
      return data;
    })
    .catch((error) => {
      onError(error as Error);
      return null;
    });
};
